/* ファイルアップローダ */
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Heading from './Heading';
import { FileInputStatus } from '../types/FileUpload';
import { KeyValue } from '../types/KeyValue';
import {
  not_submitted_value,
  document_status,
  default_document_type,
  document_cd,
} from '../const/FileUpload';
import Messages from './Messages';
interface Props {
  file_input: FileInputStatus;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>, num: number) => void;
  handleUpload: (num: number) => void;
  num: number;
  handleAddInput: (num: number) => void;
  handleDelete: (num: number) => void;
  handleCancel: (num: number) => void;
  document_type_source: KeyValue[];
  handleSelectDocumentType: (num: number, value: string) => void;
  max_input: number;
  setPreviewModalShow: (
    show: boolean,
    image_source: string,
    width: number,
    height: number,
    mime: string
  ) => void;
  can_mask: boolean;
  shelf_type: string;
  handleClickMask: () => void;
  looks_inactive: boolean;
}

const FileUpload: React.FC<Props> = ({
  file_input,
  handleChange,
  handleUpload,
  num,
  handleAddInput,
  handleDelete,
  handleCancel,
  document_type_source,
  handleSelectDocumentType,
  max_input,
  setPreviewModalShow,
  can_mask,
  handleClickMask,
  looks_inactive,
}) => {
  // 実行ボタン類の表示
  const displayActionButton = () => {
    if (file_input['is_uploaded']) {
      return (
        <div className="preview-box">
          {file_input.file.mime !== null && file_input.file.mime.match(/^image/) ? (
            <img src={file_input['file'].img} onClick={handleClickImage} />
          ) : (
            <img src="/img/mock_file.png" className="ico-common-file" />
          )}
          {!looks_inactive && (
            <>
              <div className="btn-s btn-cancel" onClick={() => handleCancel(num)}>
                取消
              </div>
              {max_input === num + 1 && (
                <div className="btn-s btn-base" onClick={() => handleAddInput(num)}>
                  画像を追加する
                </div>
              )}
            </>
          )}
        </div>
      );
    } else if (!file_input['is_uploaded'] && file_input['file']['file_body'] && !looks_inactive) {
      return (
        <div className="preview-box">
          {file_input.file.mime !== null && file_input.file.mime.match(/^image/) ? (
            <img src={file_input['file'].img} onClick={handleClickImage} />
          ) : (
            <img src="/img/mock_file.png" className="ico-common-file" />
          )}
          {can_mask && file_input.file.mime.match(/^image/) && (
            <div className="btn-s btn-base" onClick={handleClickMask}>
              マスク
            </div>
          )}
          <div className="btn-s btn-base upload-img" onClick={() => handleUpload(num)}>
            画像をアップロードする
          </div>
          <div className="text-center">
            <Messages
              help_msg="追加した提出書類にお間違いがない場合、必要に応じてマスク登録後、「画像をアップロードする」を押して下さい"
              valid_msg={file_input.errors.file_required}
            />
          </div>
        </div>
      );
    }
  };

  // 提出状態の表示
  const dispaySubmissionStatus = () => {
    if (file_input['document_status'] === document_status.no_submission) {
      return <b className="document-status-red">{file_input['document_status']}</b>;
    }
    return <>{file_input['document_status']}</>;
  };

  const handleDocTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    handleSelectDocumentType(num, event.currentTarget.value);
  };

  // PreviewModalの表示
  const handleClickImage = () => {
    setPreviewModalShow(
      true,
      file_input.file.img,
      file_input.file.width,
      file_input.file.height,
      file_input.file.mime
    );
  };

  // 本人確認資料アコーディオンの書類種別にて、運転免許証を選択した場合にガイドテキストを表示する
  const showDriverLicenseGuideText = () => {
    if (file_input.document_type === document_cd.driver_license) {
      return (
        <p>
          本人確認資料として運転免許証をご提出いただく場合は、表面・裏面の両方をアップロードして下さい。
        </p>
      );
    } else {
      return null;
    }
  };

  return (
    <>
      <div className="upload-contents-box" key={num}>
        {showDriverLicenseGuideText()}
        <div className="upload-num">
          <Row>
            {file_input.is_uploaded ? (
              <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                アップロード画像{num + 1}
              </Col>
            ) : (
              <Col xs={6} sm={6} md={6} lg={6} xl={6}></Col>
            )}
            {!looks_inactive && (
              <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                {num >= 1 && (
                  <div className="btn-s btn-red btn-delete" onClick={() => handleDelete(num)}>
                    削除
                  </div>
                )}
              </Col>
            )}
          </Row>
        </div>
        <div className="ac-contents-top">
          <div className="ac-contents-left">
            <div className="img-selection">
              <Heading label="書類種別" size="s" />
              <div className="select p-select">
                <select
                  name=""
                  id=""
                  className="c-select file-select"
                  onChange={handleDocTypeChange}
                  value={
                    !file_input.is_uploaded && looks_inactive
                      ? default_document_type
                      : file_input.document_type
                  }
                  disabled={file_input.is_uploaded || looks_inactive}
                >
                  {document_type_source.map((type: KeyValue, index: number) => {
                    return (
                      <option key={index} value={type.key}>
                        {type.value}
                      </option>
                    );
                  })}
                </select>
              </div>
              <Messages valid_msg={file_input.errors.document_type} />
            </div>
            {!looks_inactive && (
              <div className="img-upload">
                <Heading label="画像選択" size="s" />
                <div className="img-select-btn">
                  <label
                    className={`btn-s btn-base add-img ${
                      file_input.document_type === not_submitted_value || file_input.is_uploaded
                        ? 'btn-disabled'
                        : ''
                    }`}
                  >
                    画像を追加
                    <input
                      id="file-input"
                      type="file"
                      hidden
                      onChange={event => handleChange(event, num)}
                      data-index={num}
                    />
                  </label>
                  <div className="file-index">ファイル名</div>
                  <div className="file-name">
                    {file_input['file'].file_name !== ''
                      ? file_input['file'].file_name
                      : '選択されていません'}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="ac-contents-right">
            <div className="file-status">
              <Heading label="提出状態" size="s" />
              <div className="data-box">
                <div className="data-box_h">提出状態</div>
                <div className="data-box_s">{dispaySubmissionStatus()}</div>
              </div>
              <div className="data-box">
                <div className="data-box_h">提出日時</div>
                <div className="data-box_s">{file_input['submission_date']}</div>
              </div>
            </div>
          </div>
        </div>
        {displayActionButton()}
      </div>
    </>
  );
};

export default FileUpload;
